import { render, staticRenderFns } from "./cenAccount.vue?vue&type=template&id=55b42699&scoped=true&"
import script from "./cenAccount.vue?vue&type=script&lang=js&"
export * from "./cenAccount.vue?vue&type=script&lang=js&"
import style0 from "./cenAccount.vue?vue&type=style&index=0&id=55b42699&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b42699",
  null
  
)

export default component.exports